/**
 * Whether a screen's filter block starts open.
 *
 * On a phone it never does. The block is six controls one per row — half the
 * screen — and the screen is for the parts. It is a tool picked up for a moment
 * and put down, not a part of the page.
 *
 * Remembering the choice there was the mistake: one exploratory tap on the
 * funnel left it open for good, which is exactly what "hidden by default"
 * is not. So the memory only applies where the block costs a single row and
 * being open is genuinely more convenient than one more click.
 */

/** The same breakpoint the stylesheet uses for a phone. */
const PHONE = '(max-width: 48rem)';

function onAPhone(): boolean {
  return window.matchMedia?.(PHONE).matches ?? false;
}

export function foldStartsOpen(key: string): boolean {
  if (onAPhone()) return false;
  try {
    return localStorage.getItem(key) !== 'shut';
  } catch {
    // Private mode. Open is the right answer on a wide screen anyway.
    return true;
  }
}

export function rememberFold(key: string, open: boolean): void {
  // Nothing to remember on a phone: the next opening starts shut regardless,
  // and writing it would only leave a value that misleads whoever reads it.
  if (onAPhone()) return;
  try {
    localStorage.setItem(key, open ? 'open' : 'shut');
  } catch {
    // Then it opens by width next time, which is the sane default.
  }
}
